import React, { useEffect, useState } from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from "@mui/material";

function formatRemaining(ms) {
  if (ms == null || ms < 0) return "0:00";
  const totalSec = Math.floor(ms / 1000);
  const min = Math.floor(totalSec / 60);
  const sec = totalSec % 60;
  return `${min}:${String(sec).padStart(2, "0")}`;
}

export function SessionExpiryDialog({ open, expiryAt, onContinue, onLogout }) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    if (!open) return;
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, [open]);

  const remaining = expiryAt ? expiryAt - now : null;

  return (
    <Dialog open={open} maxWidth="xs" fullWidth>
      <DialogTitle>Tu sesión expira pronto</DialogTitle>
      <DialogContent>
        <Typography variant="body2" color="text.secondary">
          Tu sesión se cerrará automáticamente en{" "}
          <strong>{formatRemaining(remaining)}</strong>. Si quieres seguir trabajando,
          continúa o vuelve a iniciar sesión.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onLogout} color="inherit">Cerrar sesión</Button>
        <Button onClick={onContinue} variant="contained">Continuar</Button>
      </DialogActions>
    </Dialog>
  );
}
